module.exports = __webpack_public_path__ + "img/contact_inner2.690b24fe.png";